import register from '../register';
import Siema from 'siema';

class Carousel extends Siema {

  addDots() {
    // create dot container and add class
    this.dots = document.createElement('div');
    this.dots.classList.add('carousel-dots');

    this.innerElements.forEach( ( el, i ) => {
      const dot = document.createElement('a');
      dot.classList.add('carousel-dots__item');

      // bind event listenter
      dot.addEventListener( 'click', () => this.goTo( i ) );

      // append container
      this.dots.appendChild( dot );
    });

    // add container full of dots after selector
    this.selector.parentNode.insertBefore(
      this.dots,
      this.selector.nextSibling
    );
  }

  updateDots() {
    this.dots.querySelectorAll('a').forEach( ( dot, i ) => {
      const addOrRemove = this.currentSlide === i ? 'add' : 'remove';
      dot.classList[ addOrRemove ]('active');
    });
  }

  updateIndex() {
    let slides = document.querySelectorAll('.awards__award');
    slides.forEach( ( el, i ) => {
      const addOrRemove = this.currentSlide + 1 === i ? 'add' : 'remove';
      el.classList[ addOrRemove ]('active');
    });
  }

}

register( 'aura-awards-carousel', () => {

  new Carousel({
    selector: '.awards--mobile',
    loop: true,
    easing: 'ease-out',
    duration: 300,
    perPage: {
      1: 1,
      900: 2
    },
    onInit() {
      this.addDots();
      this.updateDots();
      this.updateIndex();
    },
    onChange() {
      this.updateDots();
      this.updateIndex();
    }
  });

});

export default undefined;
